// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2FkRM","form":"styles_form__3EYB_"};